var initLightBox = document.querySelector('[data-event="init-lightbox"]');

if (initLightBox) {
    $('.lightbox').lightBox({fixedNavigation: true});
}
